import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react'
import React from 'react'
import { useLanguage } from '../../hooks/utility/useLanguage'
import { Agent } from '../../types/agentTypes'
import { KnowledgeSource } from '../../types/chatTypes'
import { ExampleQuestionCard } from '../cards/ExampleQuestionCard'

const noop = () => undefined

interface EmptyStateMessageProps {
  agent: Agent
  onQuestionClick?: (question: string, searchKnowledgeSource: KnowledgeSource) => void
}

export const AgentWatermark: React.FC<EmptyStateMessageProps> = ({ agent, onQuestionClick }) => {
  const { t } = useLanguage()
  const descriptionColor = useColorModeValue('gray.600', 'gray.300')
  const description = (agent.name === 'AVA' ? t('fallbackAgentDescription') : agent.description || '').trim()

  const handleQuestionClick = (question: string) => {
    if (onQuestionClick) {
      const searchKnowledgeSource = 'LLM_ONLY'
      onQuestionClick(question, searchKnowledgeSource)
    }
  }

  return (
    <Flex direction='column' align='center' justify='center' h='75vh' w='100%' textAlign='center'>
      {/* TODO: Replace agentIconUrl with actual chatbot profile picture */}
      <Box pb={1} mb={2}>
        <Text fontSize={['2xl', '3xl']} fontWeight='bold'>
          {agent.name}
        </Text>
        {agent.job_category?.name && (
          <Text fontSize='sm' color='gray.400' fontWeight='normal' borderRadius='md' display='inline-block'>
            {agent.job_category.name}
          </Text>
        )}
      </Box>

      {description && (
        <Text fontSize='md' color={descriptionColor} mt={2} maxW='400px' mx='auto'>
          {description}
        </Text>
      )}

      {/* Example Questions */}
      {agent.example_questions && agent.example_questions.length > 0 && (
        <Box mt={8} maxW='600px' mx='auto'>
          <Box
            display='grid'
            gap={2}
            sx={{
              gridTemplateColumns: {
                base: '1fr',
                md: `repeat(${Math.min(agent.example_questions.length, 2)}, 1fr)`,
              },
            }}
          >
            {agent.example_questions.map((question, idx) => (
              <ExampleQuestionCard
                key={idx}
                question={question}
                isEditing={false}
                isEditable={false}
                onEditStart={noop}
                onEditSave={noop}
                onRemove={noop}
                onEditCancel={noop}
                onClick={() => handleQuestionClick(question)}
                minH='60px'
                w='100%'
              />
            ))}
          </Box>
        </Box>
      )}
    </Flex>
  )
}
